import { Alert } from '@mui/material'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetStatusState } from '../../../slices/statusSlice'
import { animations } from '../../../utils/animations'

export const CustomAlert = (props) => {
  const {type, message, alert} = useSelector(state => state.status)
  const dispatch = useDispatch()
  const [close, setClose] = useState(false)

  useEffect(() => {
    let timer
    if(alert) {
      timer = setTimeout(() => {
        setClose(true)
        setTimeout(() => {
          dispatch(resetStatusState())
        }, 2000);
      }, 4000);
    }
    return () => {
      clearTimeout(timer)
    }
  }, [ message ])
  return (
    <Alert severity={type ? type : ''} sx={{width: 300, position: 'fixed', top: 10, right: 10, zIndex: alert ? 10000 : -10}} className={!close ? animations.fadeRight : animations.fadeOut}>{message}</Alert>
  )
}
